import { PUBLISHED_STRUCTURED_CONTENT_FIELDS } from '../../fragments/message/published-structured-content-fields';
import { gql } from 'apollo-boost';
import { READ_ONLY_URL_META_FIELDS } from '../../fragments/message/read-only-url-meta-fields';

export const GET_PUBLISHED_FOLDER = gql`
    query getPublishedFolder($data: GetPublishedFolderInput!) {
        getPublishedFolder(data: $data) {
            folder {
                id
                title
                createdAt
                linkRole
                allowAnonymousContributions
                allowCopy
                discoverable
            }
            messages {
                cursor
                messages {
                    id
                    title
                    body
                    createdAt
                    image {
                        url
                        cdn_url
                        thumbnail {
                            sm
                            md
                            lg
                            xl
                            original
                        }
                        name
                        displayName
                        type
                        format
                        width
                        height
                    }
                    file {
                        url
                        cdn_url
                        name
                        displayName
                        type
                        format
                        size
                        mime
                    }
                    ${READ_ONLY_URL_META_FIELDS}
                    caption
                    keywords
                    ocrText
                    transcript { text source status sourceUrl urlMetaIndex segments { start end text } }
                    transcriptionSegments { start end text }
                    ${PUBLISHED_STRUCTURED_CONTENT_FIELDS}
                    type {
                        type
                    }
                    sourceHost
                    sourceUrls
                    canonicalSourceUrls
                }
            }
        }
    }
`;
